import React from "react";
import MotivosBaseTemplate from "../shared/MotivosBaseTemplate";
import {
  alterarStatusMotivoVagoes,
  cadastrarMotivoVagoes,
  editarMotivoVagoes,
  excluirMotivoVagoes,
  listarMotivosVagoes,
} from "./motivosVagoes.api";

export default function MotivosVagoesBase() {
  return (
    <MotivosBaseTemplate
      titulo="Motivos VAGÕES"
      descricao="Cadastre os motivos usados pelas interdições de VAGÕES do CIM."
      placeholder="Ex.: FREIO AGARRADO"
      hint="Use esta base para centralizar os motivos de VAGÕES no CIM."
      listFn={listarMotivosVagoes}
      createFn={cadastrarMotivoVagoes}
      updateFn={editarMotivoVagoes}
      deleteFn={excluirMotivoVagoes}
      toggleFn={alterarStatusMotivoVagoes}
    />
  );
}
